import { render, staticRenderFns } from "./RegisterDisclosure.vue?vue&type=template&id=2afef550&scoped=true&"
import script from "./RegisterDisclosure.vue?vue&type=script&lang=js&"
export * from "./RegisterDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDisclosure.vue?vue&type=style&index=0&id=2afef550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afef550",
  null
  
)

export default component.exports